















import Vue from 'vue';

export default Vue.extend({
  name: 'HRating',
  props: {
    value: {
      type: Number,
      required: true,
    },
    color: {
      type: String,
      default: 'light-green lighten-1',
    },
    readonly: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    value(newValue) {
      this.rating = newValue;
    },
  },
  data() {
    return {
      rating: this.value,
    };
  },
  methods: {
    onInput() {
      this.$emit('change', this.rating);
    },
  },
});
